var _g, _g2, _path, _path2, _path3, _path4, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256.9,
    height: 102.311,
    viewBox: "0 0 256.9 102.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(-513.04 -90.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M654.561,105.494h-4.813l2.4,5L665.291,137.8a28.106,28.106,0,0,0,2.168-4.134q.155-.369.3-.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M647.339,110.493l-2.4-5h-4.813l2.405,5,2.406,5,2.407,5,11.678,24.272a28.227,28.227,0,0,0,2.4-2.145q.471-.471.918-.961L649.746,115.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M642.526,120.5l-2.407-5-2.407-5-2.4-5h-4.813l2.4,5,2.407,5,2.406,5,2.407,5,2.407,5,8.931,18.564q.5-.19,1-.4a28.335,28.335,0,0,0,2.925-1.441L644.932,125.5Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M630.494,105.494h0l-14.278,29.679-1.911,3.971a31.443,31.443,0,0,0,2.883,4.013l1.726-3.589L632.9,110.493Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M635.306,115.5l-13.274,27.59-1.626,3.379a31.837,31.837,0,0,0,3.511,2.707l1.572-3.268,12.223-25.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M640.119,125.5,629.25,148.091l-1.555,3.233q.7.339,1.429.646,1.285.543,2.607.97l1.571-3.267,9.224-19.17Z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M670.762,110.331A31.777,31.777,0,1,0,614.3,139.144l1.911-3.971q-.366-.741-.69-1.506a28.181,28.181,0,1,1,52.237-.74q-.145.37-.3.74a28.067,28.067,0,0,1-5.123,8q-.447.49-.918.961a28.081,28.081,0,0,1-8.959,6.041q-.5.21-1,.4a28.336,28.336,0,0,1-18.155.606l-1.571,3.267a31.91,31.91,0,0,0,21.286-.63c.281-.109.561-.223.84-.34a32.122,32.122,0,0,0,3.086-1.506,31.659,31.659,0,0,0,3.664-2.388,32.005,32.005,0,0,0,3.347-2.914l.044-.044a31.962,31.962,0,0,0,3.085-3.591,31.582,31.582,0,0,0,2.708-4.378q.52-1.021.971-2.085a31.872,31.872,0,0,0,0-24.733Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M632.9,110.493l-2.4-5h0l-2.406,5,2.405,5v0l2.407-5Z",
    fill: "#c4c5c7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M635.3,115.5l-2.407,5,2.407,5,2.407-5Z",
    fill: "#c4c5c7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M640.118,125.5l-2.407,5,2.407,5,2.407-5Z",
    fill: "#c4c5c7"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M528.314,190l1.112,2.827h5.247L526.23,172.78h-4.719l-8.471,20.049H518.3l5.558-14.274Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M558.032,179.082h-4.983a2.881,2.881,0,0,0-3.224-2.521c-1.7,0-2.844.7-2.844,1.993,0,1.085.792,1.554,2.287,1.876l2.784.645c3.635.792,6.009,2.257,6.009,5.687,0,3.986-3.283,6.477-8.266,6.477-4.484,0-8.529-2.11-9-7.034h4.953c.323,1.758,1.847,2.813,4.192,2.813,1.847,0,2.814-.674,2.814-1.758,0-.674-.41-1.378-2.111-1.7l-3.282-.733c-3.928-.85-5.775-2.7-5.775-5.862,0-3.986,3.225-6.507,7.914-6.507C552.726,172.458,557.533,173.718,558.032,179.082Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M574.943,172.9c5.188,0,8.441,2.814,8.441,7.3,0,4.66-3.4,7.562-8.851,7.562h-2.668v5.071h-4.953V172.9Zm-.117,10.523c2.2,0,3.605-1.26,3.605-3.224,0-1.788-1.407-2.931-3.605-2.931h-2.961v6.155Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M596.251,192.829H591.3V172.9h4.954Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M610.583,187.054v5.775H605.63V172.9h8.734c4.925,0,8.237,2.7,8.237,7.006a6.7,6.7,0,0,1-3.811,6.184l5.13,6.742h-5.98l-4.279-5.775Zm3.664-4.455c1.9,0,3.43-1.055,3.43-2.7,0-1.613-1.525-2.638-3.43-2.638h-3.664V182.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M667.268,177.323v15.506h-4.953V177.323h-6.361V172.9H673.6v4.426Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M686.641,192.829h-4.953V172.9h4.953Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M716.684,182.863A10.568,10.568,0,1,1,706.1,172.487,10.313,10.313,0,0,1,716.684,182.863Zm-5.041,0a5.545,5.545,0,1,0-5.54,5.774A5.589,5.589,0,0,0,711.643,182.863Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M743.913,192.829h-3.84L730.517,181.9v10.933h-4.953V172.9h3.781l9.614,11.226V172.9h4.954Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M769.911,179.082h-4.983a2.881,2.881,0,0,0-3.225-2.521c-1.7,0-2.843.7-2.843,1.993,0,1.085.792,1.554,2.287,1.876l2.784.645c3.634.792,6.009,2.257,6.009,5.687,0,3.986-3.283,6.477-8.266,6.477-4.484,0-8.53-2.11-9-7.034h4.953c.323,1.758,1.847,2.813,4.192,2.813,1.846,0,2.813-.674,2.813-1.758,0-.674-.41-1.378-2.11-1.7l-3.283-.733c-3.927-.85-5.774-2.7-5.774-5.862,0-3.986,3.224-6.507,7.914-6.507C764.6,172.458,769.412,173.718,769.911,179.082Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M645.913,190l1.112,2.827h5.247l-8.442-20.049H639.11l-8.471,20.049H635.9l5.558-14.274Z",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1463baf0ff76983cdb33f88fd3ef1302.svg";
export { ForwardRef as ReactComponent };